export default {
  isLoading: (state) => state.meta.isLoading,
  hasLoaded: (state) => {
    return !!state.meta.loadedOn
  },
  didLoadFail: (state) => {
    return !!state.meta.loadedOn && state.meta.error
  },
}
